import axios from 'axios';
import API_CONFIG from '../config/api';

const contactService = {
  /**
   * Send contact form submission
   * @param {Object} formData - Contact form data
   * @param {string} formData.fullName - Full name
   * @param {string} formData.email - Email address
   * @param {string} formData.phone - Phone number (optional)
   * @param {string} formData.subject - Subject
   * @param {string} formData.comments - Message/comments
   * @returns {Promise} Response data
   */
  sendContactForm: async (formData) => {
    try {
      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/contact`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: API_CONFIG.TIMEOUT,
        }
      );
      return response.data;
    } catch (error) {
      // Handle rate limit errors (429 Too Many Requests)
      if (error.response?.status === 429) {
        const rateLimitError = new Error(error.response.data?.message || 'Too many requests. Please try again later.');
        rateLimitError.isRateLimit = true;
        rateLimitError.retryAfter = error.response.data?.retryAfter || null;
        throw rateLimitError;
      }
      // Handle validation errors
      if (error.response?.data?.errors) {
        const validationError = new Error(error.response.data.message || 'Validation failed');
        validationError.errors = error.response.data.errors;
        throw validationError;
      }
      // Handle other errors
      const errorMessage = error.response?.data?.message || error.message || 'Failed to send message. Please try again later.';
      throw new Error(errorMessage);
    }
  },
};

export default contactService;

